/*
 *
 * MainLayout constants
 *
 */

import React from 'react';
import { PG_DASHBOARD_MENU_URL_MAPPING } from 'utils/constants';
import { ICON_NAME } from 'components/CustomIcons/types';
import CustomIcons from 'components/CustomIcons';

export const DEFAULT_ACTION = 'app/MainLayout/DEFAULT_ACTION';

export const SUSPICIOUS_TRANSACTION = 'Suspicious Transactions';
export const EMBEDDABLE_COMPONENTS_KEY = 'embeddable-components';

export const OCC_ACTIVATED_SUB_PRODUCTS_KEY = ['offers', 'customisation'];

export const featuresItems = [
  {
    rank: 1,
    key: 'summary',
    icon: iconProps => <CustomIcons componentName="SUMMARY" {...iconProps} />,
    displayText: 'Summary',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'summary/overview',
        displayText: 'Overview',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'summary/analytics',
        displayText: 'Analytics',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    rank: 3,
    key: 'settlements',
    icon: iconProps => (
      <CustomIcons componentName="SETTLEMENTS" {...iconProps} />
    ),
    displayText: 'Settlements',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'settlements/standard',
        displayText: 'Standard',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'settlements/vendor',
        displayText: 'Vendor',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 3,
        key: 'settlements/on-demand',
        displayText: 'On-Demand',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      // {
      //   rank: 2,
      //   key: 'settlements/instant',
      //   displayText: 'Instant',
      //   isNew: false,
      //   isDisabled: false,
      //   isVisible: true,
      //   isParent: false,
      // },
    ],
  },
  {
    rank: 2,
    key: 'transactions',
    icon: iconProps => (
      <CustomIcons componentName="TRANSACTIONS" {...iconProps} />
    ),
    displayText: 'Transactions',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 2,
        key: 'transactions/orders',
        displayText: 'Orders',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 4,
        key: 'transactions/disputes',
        displayText: 'Disputes',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
        children: [],
      },
      {
        rank: 1,
        key: 'transactions/payments',
        displayText: 'Payments',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
        children: [],
      },
      {
        rank: 3,
        key: 'transactions/refunds',
        displayText: 'Refunds',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 5,
        key: 'transactions/suspicious',
        displayText: SUSPICIOUS_TRANSACTION,
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
        children: [],
      },
    ],
  },
  {
    rank: 4,
    key: 'vba-configuration',
    icon: iconProps => <CustomIcons componentName="VBA" {...iconProps} />,
    displayText: 'VBA Configuration',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'vba-configuration/accounts',
        displayText: 'VBA Accounts',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'vba-configuration/notification-groups',
        displayText: 'Notification Groups',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    rank: 6,
    key: 'payment-links',
    icon: iconProps => (
      <CustomIcons componentName="PAYMENT_LINKS" {...iconProps} />
    ),
    displayText: 'Payment Links',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'payment-links/all',
        displayText: 'All',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'payment-links/orders',
        displayText: 'Orders',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 3,
        key: 'payment-links/batch',
        displayText: 'Batch',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    rank: 6,
    key: 'apps',
    icon: iconProps => <CustomIcons componentName="APPS" {...iconProps} />,
    displayText: 'Apps',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
  {
    rank: 5,
    key: 'offers',
    icon: iconProps => <CustomIcons componentName="OFFERS" {...iconProps} />,
    displayText: 'Offers',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
  // PGDB-3470
  // {
  //   rank: 7,
  //   key: 'qr-code',
  //   icon: iconProps => <CustomIcons componentName="QR_CODE" {...iconProps} />,
  //   displayText: 'QR Code',
  //   isNew: true,
  //   isDisabled: false,
  //   isVisible: true,
  //   isParent: false,
  // },
  {
    rank: 8,
    key: 'customers',
    icon: iconProps => <CustomIcons componentName="CUSTOMERS" {...iconProps} />,
    displayText: 'Customers',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'customers/active',
        displayText: 'Active',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'customers/unfulfilled',
        displayText: 'Unfulfilled',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    rank: 9,
    key: 'customisation',
    icon: iconProps => (
      <CustomIcons
        componentName={ICON_NAME.CHECKOUT_CUSTOMISATIONS}
        {...iconProps}
      />
    ),
    displayText: 'Customisation',
    hideHeader: true,
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
];

export const FLOWWISE = 'flowwise';

export const subProductsItems = [
  {
    rank: 3,
    key: 'payment-forms',
    icon: iconProps => (
      <CustomIcons componentName="PAYMENT_FORMS" {...iconProps} />
    ),
    displayText: 'Payment Forms',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'payment-forms/all',
        displayText: 'All',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'payment-forms/orders',
        displayText: 'Orders',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 3,
        key: 'payment-forms/intelli-forms',
        displayText: 'Intelli Forms',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    rank: 2,
    key: 'easy-split',
    icon: iconProps => (
      <CustomIcons componentName="EASY_SPLIT" {...iconProps} />
    ),
    displayText: 'Easy Split',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'easy-split/vendors',
        displayText: 'Vendors',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'easy-split/transactions',
        displayText: 'Transactions',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 3,
        key: 'easy-split/refunds',
        displayText: 'Refunds',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 4,
        key: 'easy-split/settlements',
        displayText: 'Settlements',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 5,
        key: 'easy-split/adjustments',
        displayText: 'Adjustments',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    rank: 6,
    key: 'softpos',
    icon: iconProps => <CustomIcons componentName="SOFTPOS" {...iconProps} />,
    displayText: 'SoftPOS',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'softpos/collection-point-management',
        displayText: 'Collection Point Management',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'softpos/payment-methods',
        displayText: 'Payment Methods',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    rank: 5,
    key: 'product-links',
    icon: iconProps => (
      <CustomIcons componentName="PRODUCT_LINKS" {...iconProps} />
    ),
    displayText: 'Product Links',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
  {
    rank: 4,
    key: 'payment-buttons',
    icon: iconProps => (
      <CustomIcons componentName="PAYMENT_FORMS" {...iconProps} />
    ),
    displayText: 'Payment Buttons',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
  {
    rank: 7,
    key: FLOWWISE,
    icon: iconProps => <CustomIcons componentName="FLOWWISE" {...iconProps} />,
    displayText: 'flowWise',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'flowwise/gateways',
        displayText: 'Gateways',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'flowwise/configurations',
        displayText: 'Configurations',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      // {
      //   rank: 3,
      //   key: 'flowwise/upfront-tdr',
      //   displayText: 'Upfront TDR',
      //   isNew: false,
      //   isDisabled: false,
      //   isVisible: true,
      //   isParent: false,
      // },
      {
        rank: 3,
        key: 'flowwise/settlement-recon',
        displayText: 'Settlement Recon',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 3,
        key: 'flowwise/insights-ai',
        displayText: 'InsightsAI',
        isNew: true,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    rank: 8,
    key: EMBEDDABLE_COMPONENTS_KEY,
    icon: iconProps => (
      <CustomIcons
        componentName={ICON_NAME.EMBEDDABLE_COMPONENTS}
        {...iconProps}
      />
    ),
    displayText: 'Embeddable Components',
  },
  {
    rank: 1,
    key: 'one-click-checkout',
    icon: iconProps => (
      <CustomIcons componentName={ICON_NAME.ECOM_360} {...iconProps} />
    ),
    displayText: 'OneClick Checkout',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
  {
    rank: 1,
    key: 'one-click-checkout-pitch',
    icon: iconProps => (
      <CustomIcons componentName={ICON_NAME.ECOM_360} {...iconProps} />
    ),
    displayText: 'OneClick Checkout',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
  {
    rank: 1,
    key: 'one-click-checkout-activated',
    icon: iconProps => (
      <CustomIcons componentName={ICON_NAME.ECOM_360} {...iconProps} />
    ),
    displayText: (
      <>
        One Click <br /> Checkout
      </>
    ),
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'one-click-checkout-activated/analytics',
        displayText: 'Analytics',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'one-click-checkout-activated/recovery-campaign',
        displayText: 'Recovery Campaign',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 3,
        key: 'one-click-checkout-activated/offers',
        displayText: 'Offers & Promotions',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 4,
        key: 'one-click-checkout-activated/rto-reduction',
        displayText: 'RTO Reduction',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 5,
        key: 'one-click-checkout-activated/customisation',
        displayText: 'Customisation',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 6,
        key: 'one-click-checkout-activated/shipping-delivery',
        displayText: 'Shipping & Delivery',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
];

export const utilitiesItems = [
  {
    rank: 1,
    key: 'risk-shield',
    icon: iconProps => (
      <CustomIcons componentName="RISKSHIELD" {...iconProps} />
    ),
    displayText: 'RiskShield',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        displayText: 'Overview',
        name: 'overview',
        rank: 1,
        key: 'risk-shield/overview',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        displayText: 'Risky Transactions',
        name: 'risky-transactions',
        rank: 2,
        key: 'risk-shield/risky-transactions',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        displayText: 'Smart Rules',
        name: 'configurations',
        rank: 3,
        key: 'risk-shield/configurations',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        displayText: 'My Blacklists',
        name: 'my-blacklists',
        rank: 4,
        key: 'risk-shield/blacklists',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    rank: 2,
    key: 'reports',
    icon: iconProps => <CustomIcons componentName="REPORTS" {...iconProps} />,
    displayText: 'Reports',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'reports/download',
        displayText: 'Download Reports',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'reports/schedule',
        displayText: 'Schedule Reports',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    rank: 4,
    key: 'developers',
    icon: iconProps => (
      <CustomIcons componentName="DEVELOPERS" {...iconProps} />
    ),
    displayText: 'Developers',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'developers/api-keys',
        displayText: 'API Keys',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'developers/api-metrics',
        displayText: 'API Logs and Alerts',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 3,
        key: 'developers/webhooks',
        displayText: 'Webhooks',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 4,
        key: 'developers/rate-limits',
        displayText: 'Rate Limits',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 5,
        key: 'developers/whitelisting',
        displayText: 'Whitelisting',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      // {
      //   rank: 6,
      //   key: 'developers/integration-usage',
      //   displayText: 'Integration Usage',
      //   isNew: false,
      //   isDisabled: false,
      //   isVisible: true,
      //   isParent: false,
      // },
      {
        rank: 7,
        key: 'developers/checkout-analytics',
        displayText: 'Checkout Analytics',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    rank: 4,
    key: 'status-page/downtimes',
    icon: iconProps => (
      <CustomIcons componentName="STATUS_PAGE" {...iconProps} />
    ),
    displayText: 'Downtimes',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
];

export const keyKeyPGMapping = {
  paymentsforms: 'PF',
  'easysplit-vendor': 'CES',
  paymentlinks: 'ORDERS',
  softpos: 'EPOS',
  router: 'ROUTER',
};

export const ONLINE_OFFLINE_SETTLEMENTS_CHILDREN = [
  {
    rank: 1,
    key: 'settlements/online',
    displayText: 'Online',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
  {
    rank: 2,
    key: 'settlements/offline',
    displayText: 'Offline',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
];

export const KEYBOARD_SHORTCUTS = {
  L: 'PAYMENT_LINK',
  P: 'PAYMENT_FORM',
  O: 'OFFER',
  B: 'PAYMENT_BUTTON',
  M: 'NO_COST_EMI',
};

export const REDIRECTION_MAPPER = {
  PAYMENT_LINK: `${
    PG_DASHBOARD_MENU_URL_MAPPING.PAYMENT_LINKS.name
  }?createPaymentLink=true`,
  PAYMENT_BUTTON: `${
    PG_DASHBOARD_MENU_URL_MAPPING.PAYMENT_BUTTONS.name
  }?createPaymentButton=true`,
  PAYMENT_FORM: `${
    PG_DASHBOARD_MENU_URL_MAPPING.PAYMENT_FORMS.name
  }?createPaymentForm=true`,
  OFFER: `${
    PG_DASHBOARD_MENU_URL_MAPPING.OFFERS.children.ALL_OFFERS
  }?createOffer=true`,
  NO_COST_EMI: `${
    PG_DASHBOARD_MENU_URL_MAPPING.OFFERS.children.ALL_OFFERS
  }?createNoCostEmi=true`,
  OCC_ACTIVATED_OFFER: `${
    PG_DASHBOARD_MENU_URL_MAPPING.ECOM_360_ACTIVATED.children
      .ECOM_360_ACTIVATED_OFFERS
  }?createOffer=true`,
  OCC_ACTIVATED_NO_COST_EMI: `${
    PG_DASHBOARD_MENU_URL_MAPPING.ECOM_360_ACTIVATED.children
      .ECOM_360_ACTIVATED_OFFERS
  }?createNoCostEmi=true`,
};

export const DROPDOWN_OPTIONS = [
  {
    key: 1,
    text: 'Payment Link',
    description:
      'Create and send payment links instantly to your customers and collect payments.',
    value: 'PAYMENT_LINK',
    shortcutKey: 'L',
  },
  {
    key: 2,
    text: 'Payment Form',
    description:
      'Personalize the payment form to reflect your brand identity and start selling online.',
    value: 'PAYMENT_FORM',
    shortcutKey: 'P',
  },
  {
    key: 3,
    text: 'Payment Button',
    description:
      'Accept payments using Cashfree Payment button in a simple, safe, and secure manner.',
    value: 'PAYMENT_BUTTON',
    shortcutKey: 'B',
  },
  {
    key: 4,
    text: 'New Offer',
    description:
      'Create new offer and specify the offer details to create a unique offer for the customer.',
    value: 'OFFER',
    shortcutKey: 'O',
  },
  {
    key: 5,
    text: 'No Cost EMI',
    description:
      'Allow your customers to buy products in monthly instalments and need not pay any interest on the product purchased.',
    value: 'NO_COST_EMI',
    shortcutKey: 'M',
  },
];

export const DEVELOPERS_TOOL_HEADER_MAPPING = {
  'api-keys': 'API Keys',
  webhooks: 'Webhooks',
  'api-metrics': 'API Logs and Alerts',
  'rate-limits': 'Rate Limits',
  // 'integration-usage': 'Integration Usage',
  'checkout-analytics': 'External Analytics',
};

export const DISPLAY_HEADER_MAPPING = {
  developers: 'Developer Tools',
};
